import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { MyPromise } from '../interceptors/myPromise.service';
import { to } from 'await-to-js'
import axios from 'axios'
import { NbAuthService } from '@nebular/auth';

const DELIVERABLESAPIURL = `${environment.baseEndpoint}/deliverablesv2`;
const API_URL_PHP = `${environment.baseEndpointPHP}`;

@Injectable({
  providedIn: 'root',
})
export class CalendarService {

  constructor(
    private http: HttpClient,
    private authService: NbAuthService,
    private myPromise: MyPromise,
  ) { }

  storeDeliverable(stationId: string, data: any) {
    return this.myPromise.to(this.http.post(`${API_URL_PHP}/deliverables/station/${stationId}`, data));
  }

  getDeliverables(stationId: any = null) {
    return stationId ? this.myPromise.to(this.http.get(`${DELIVERABLESAPIURL}/${stationId}`)) : this.myPromise.to(this.http.get(`${DELIVERABLESAPIURL}`));
  }

  async storeFile(event: any, file) {
    const payload = localStorage.getItem('access_token')
    if (!payload) return [{message: 'Error contacte a soporte'}] 
    const token = JSON.parse(payload)
    const data = new FormData();
    data.append('file', file);
    data.append('data', JSON.stringify(event));
    return await to(axios.put(`${DELIVERABLESAPIURL}/${event.id}`, data, { headers: { authorization: token.data }}));
  }

  async updateImage(event: any, file) {
    const payload = localStorage.getItem('access_token')
    if (!payload) return [{message: 'Error contacte a soporte'}] 
    const token = JSON.parse(payload)
    const data = new FormData();
    data.append('file', file);
    return await to(axios.put(`${DELIVERABLESAPIURL}/${event.id}/image`, data, { headers: { authorization: token.data }}));
  }

  getDeliverablesByDependence(stationId: string, dependenceId: string) {
    return this.myPromise.to(this.http.get(`${DELIVERABLESAPIURL}/${stationId}?dependenceId=${dependenceId}`));
  }

  deleteDeliverable(deliverableId: string) {
    return this.myPromise.to(this.http.delete(`${API_URL_PHP}/deliverables/${deliverableId}`));
  }

  editDeliverableFile(deliverableId: string, data: any) {
    return this.myPromise.to(this.http.put(`${API_URL_PHP}/deliverables/${deliverableId}`, { data }));
  }

  cancelDeliver(legalRequirementId) {
    return this.myPromise.to(this.http.delete(`${DELIVERABLESAPIURL}/${legalRequirementId}`));
  }
}
